export class MetaElementFeaturePropertyDef {
  public static readonly DISTANCE: string = 'distance';
  public static readonly TYPE_MARKING_STRIP_PREFIX: string = 'MarkingStrip';
  public static readonly TYPE_WMB_PREFIX: string = 'WMB';
  public static readonly TYPE_MINI_WSB: string = 'Mini-WSB';
  public static readonly TYPE_WSB: string = 'WSB';
  public static readonly TYPE_WSB4: string = 'WSB4';
  public static readonly TYPE_ETIKETTEN: string = '209-113';
  public static readonly TYPE_LABEL_CARD: string = 'label-card';
}
